<template >
  <div class="backgroundStyle">
    <v-container fluid>
      <v-layout column>
        <v-flex xs12>
          <div class="resultContainer">
            <v-layout align-center justify-center fill-height>
              <v-card
                min-width="350px"
                justify-center
                class="px-1 mx-3 text-xs-center rounded-card my-0"
                style="margin: 0"
              >
                  <!-- <v-card-title justify-center> -->
                <v-img class="ma-2"  min-width="40px" src="/glue_logo_1.png"></v-img>
                  <!-- </v-card-title> -->
                <v-card-text >

                  <v-flex class="grey--text" v-if="successfullyResetPassword">
                    <h3>Password Successfully Reset:</h3>
                    <h5>Please check your mail for your new credentials!</h5>
                    <br />
                  </v-flex>

                  <v-flex v-if="!resetPasswordCard" xs12>
                    <v-text-field
                      id="usernameId"
                      clearable
                      prepend-icon="mail"
                      color="#8c388d"
                      label="Email/Username"
                      v-model="emailAddress"
                      v-on:keyup.enter="login"
                    ></v-text-field>
                    <br />
                    <v-text-field
                      id="passwordId"
                      prepend-icon="vpn_key"
                      color="#8c388d"
                      :append-icon="show1 ? 'visibility' : 'visibility_off'"
                      :rules="[rules.min]"
                      :type="show1 ? 'text' : 'password'"
                      label="Password"
                      class="text-xs-center"
                      v-model="password"
                      @click:append="show1 = !show1"
                      v-on:keyup.enter="login"
                    ></v-text-field>
                    <v-btn
                      v-if="!loadingLogin"
                      id="loginButtonId"
                      dark
                      round
                      style="color: #8c388d"
                      color="#8c388d"
                      class='white--text'
                      @click="login"
                    >Login</v-btn>
                    <v-btn v-else-if="loadingLogin" round disabled>
                          <span>Logging In </span>  <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
                    <!-- <v-layout v-if="loadingLogin" row justify-center>
                      <v-flex>
                        <vue-loaders-ball-spin-fade-loader
                          :key="loadingLogin"
                          color="grey"
                          scale="0.5"
                        ></vue-loaders-ball-spin-fade-loader>
                      </v-flex>
                    </v-layout> -->

                    <br />
                    <!-- <br> -->
                    <v-btn flat @click="resetPasswordCard=true">Forgot Password</v-btn>
                    <br />
                    <div class="danger-alert" v-html="error" />
                    <br />
                    <div v-show="errorMessage">
                      <span>Login Failed</span>
                    </div>
                    <div class="red--text" v-show="passwordError">
                      <span>Invalid Email/Password Combination</span>
                    </div>
                  </v-flex>

                  <v-flex v-if="resetPasswordCard&&!successfullyResetPassword">
                    <v-flex>
                      <h3 class="grey--text">Reset Password</h3>
                    </v-flex>
                    <v-text-field
                      clearable
                      color="#8c388d"
                      prepend-icon="mail"
                      label="Email Address"
                      v-model="emailAddress"
                    ></v-text-field>
                    <br />
                    <v-btn
                      v-if="emailAddress"
                      dark
                      round
                      @click="resetPassword"
                      style="color: #8c388d"
                      color="#8c388d"
                      class='white--text'
                    >RESET PASSWORD</v-btn>
                    <v-btn v-else disabled round>RESET PASSWORD</v-btn>
                    <br />
                    <v-btn round dark style="color: #8c388d"
                      color="#8c388d"
                      class='white--text' @click="resetPasswordCard=false">Back</v-btn>
                    <br />
                    <div class="danger-alert" v-html="error" />
                    <br />
                    <div v-show="errorMessage">
                      <span>Login Failed</span>
                    </div>
                    <div class="red--text" v-show="emailVerifyFailed">
                      <span>Invalid Email Address</span>
                    </div>
                  </v-flex>
                </v-card-text>
              </v-card>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// import AuthenticationService from '@/services/AuthenticationService'
import Api from "@/services/Api";
import configData from "../../../config/config.json";

export default {
  data() {
    return {
      resetPasswordCard: false,
      newPassword: "",
      show1: false,
      successfullyResetPassword: false,
      email: "",
      emailAddress: "",
      errorMessage: false,
      passwordError: false,
      password: "",
      error: null,
      loadingLogin: false,
      orgLogo: null,
      emailVerifyFailed: false,
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 8 || "Min 8 characters",
        emailMatch: () => "The email and password you entered don't match"
      }
    };
  },
  async created() {
      this.config = configData;
      await this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setPermission", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.dispatch("setCustomerId", null);
      this.$store.dispatch("setIsUserLoggedIn", false);
      this.$store.dispatch("setCurrentOrg", null);
      this.$store.dispatch("setOrgToken", null);
      this.$store.dispatch("setCurrentRoute", null);
      this.$store.dispatch("setOrganisations", null);
    if(this.$route.query.name){
      this.fetchLogo()
    }
  },
  async mounted(){
      await this.$store.dispatch("setToken", null);

  },
  methods: {
    async fetchLogo(){
      await Api().get('/organisation/logo',{
        params: {
          name: this.$route.query.name
        }
      }).then(response=>{
        if(response.data){
          this.orgLogo = response.data.logo
        }
        
      })
    },
    async login() {
      try {
        console.log(this.$store.state)
        this.loadingLogin = true;
        this.passwordError = false;
        Api()
          .post("/login", {
            emailAddress: this.emailAddress,
            password: this.password
          })
          .then(async response => {
            if (
              response.status === 403 ||
              response.status === 401 ||
              response.status === 500
            ) {
              this.errorMessage = true;
              this.loadingLogin = false;
            }
            let orgId = null;
            let orgToken = null;

            await this.$store.dispatch("setToken", response.data.token);
            await this.$store.dispatch("setUser", response.data.user);
            this.$store.dispatch(
              "setPermission",
              response.data.user.permissions
            );
            this.$store.dispatch("setIsUserLoggedIn", true);

            let organisations = [];
            let allOrganisations = [];
            var orgPermission = null;
            await Api()
              .get("/contacts/permission/" + response.data.user.id)
              .then(async response => {
                // debugger
                await this.$store.dispatch(
                  "setOrganisations",
                  response.data.organisations
                );
                await this.$store.dispatch(
                  "setCurrentOrg",
                  response.data.organisations[0]
                );
                this.$vuetify.theme.primary =
                  response.data.organisations[0].org.primaryColour;
                this.$vuetify.theme.secondary =
                  response.data.organisations[0].org.secondaryColour;
                this.$vuetify.theme.navbarColour =
                  response.data.organisations[0].org.navbarColour;
                this.$vuetify.theme.navbarTextColour =
                  response.data.organisations[0].org.navbarTextColour;
                await this.$store.dispatch(
                  "setOrgToken",
                  response.data.organisations[0].org.token
                );
                if(response.data.organisations[0].org.frontendRoutes.length>0){
if (
                  response.data.organisations[0].org.frontendRoutes.includes(
                    "/fnoDashboard"
                  )
                ) {
                  await this.$router.push({ path: "/fnoDashboard" });
                } else if (
                  response.data.organisations[0].org.frontendRoutes.includes(
                    "/ispDashboard"
                  )
                ) {
                  await this.$router.push({ path: "/ispDashboard" });
                } else if (
                  response.data.organisations[0].org.frontendRoutes.includes(
                    "/resellerPortal"
                  )
                ) {
                  await this.$router.push({ path: "/resellerPortal" });
                }else {
                  let initialRoute =
                    response.data.organisations[0].org.frontendRoutes[0];
                  await this.$router.push({ path: initialRoute });
                }
                } else if(response.data.organisations.length>0){
                  let find = response.data.organisations.find(x=>x.org.frontendRoutes.length>0)
                  if(find){
                    await this.$store.dispatch(
                  "setCurrentOrg",
                  find
                );
                this.$vuetify.theme.primary =
                  find.org.primaryColour;
                this.$vuetify.theme.secondary =
                  find.org.secondaryColour;
                this.$vuetify.theme.navbarColour =
                  find.org.navbarColour;
                this.$vuetify.theme.navbarTextColour =
                  find.org.navbarTextColour;
                await this.$store.dispatch(
                  "setOrgToken",
                  find.org.token
                );
if (
                  find.org.frontendRoutes.includes(
                    "/fnoDashboard"
                  )
                ) {
                  await this.$router.push({ path: "/fnoDashboard" });
                } else if (
                  find.org.frontendRoutes.includes(
                    "/ispDashboard"
                  )
                ) {
                  await this.$router.push({ path: "/ispDashboard" });
                } else if (
                  find.org.frontendRoutes.includes(
                    "/resellerPortal"
                  )
                ) {
                  await this.$router.push({ path: "/resellerPortal" });
                }else {
                  let initialRoute =
                    find.org.frontendRoutes[0];
                  await this.$router.push({ path: initialRoute });
                }

                  }
                }

                
              });
          })
          .catch(err => {
            this.passwordError = true;
            this.loadingLogin = false;
          });
      } catch (error) {
        this.error = error.response.data.error;
        this.loadingLogin = false;
      }
    },

    resetPassword() {
      this.passwordError = false
      this.emailVerifyFailed = false
      try {       
        Api()
          .post("/resetPassword", {
              emailAddress: this.emailAddress            
          })
          .then(response => {
            if (response.data=='Invalid') {
                  this.emailVerifyFailed = true;
                  this.passwordError = true;
                  this.resetPasswordCard = false;
            } else {
                  this.successfullyResetPassword = true;
                  this.resetPasswordCard = false;
            }
          })
          .catch(err => {
            this.emailVerifyFailed = true;
            this.passwordError = true;
          });
      } catch (error) {
        this.error = error.response.data.error;
        this.loadingLogin = false;
      }
    }
  }
};
</script>
<style scoped>
.resultContainer {
  height: 96vh;
}
.backgroundStyle {
  background-color: #333333;
}
/* body {background-color:"";} */
.item {
  min-height: 50px;
  min-width: 80px;
  margin: 10px;
}
.rounded-card {
  border-radius: 50px;
}
</style>

